import { Card, DialogCloseButton, Button, Spacer } from '@sparemin/blockhead';
import HeadphonesGradient from 'components/icons/HeadphonesGradient';
import { useBreakpoints } from 'context/BreakpointsContext';
import { useEventTracking } from 'context/EventTrackingContext';
import { useModalControls } from 'context/ModalContext';
import React from 'react';
import { DASHBOARD_PROMO_URL } from 'utils/constants';
import styles from './SponsoredEpisodeModalContents.module.scss';

type SponsoredEpisodeModalContentsProps = {};

const SponsoredEpisodeModalContents: React.FC<
  SponsoredEpisodeModalContentsProps
> = () => {
  const { md } = useBreakpoints();
  const { close } = useModalControls();
  const { trackClickSponsoredResultsModalCTA } = useEventTracking();

  return (
    <Card
      header={
        <Card.Header
          icon={<HeadphonesGradient />}
          title="Sponsored episodes"
          subtitle="We let podcasters promote their episodes on Headliner to connect with
          listeners like you. If you’re a podcast, you can do the same!"
          actionButton={<DialogCloseButton onPress={close} />}
        />
      }
      fullScreen={md}
      className={styles.card}
    >
      <Card.Contents
        as={Spacer}
        space="30px"
        orientation="vertical"
        align="center"
      >
        <Button
          as="a"
          href={DASHBOARD_PROMO_URL}
          variant="solid"
          fluid
          target="_blank"
          onPress={trackClickSponsoredResultsModalCTA}
        >
          boost your podcast
        </Button>
      </Card.Contents>
    </Card>
  );
};
export default SponsoredEpisodeModalContents;
